<template>
   <div>
      <div class="mt-4 pt-4">
         <h1>Scanner</h1>
         <div class="mt-4">
            <div class="row">
               <div class="col-12">
                  <div class="card">
                     <div class="card-header mb-4">
                        <div class="position-relative m-4">
                           <div class="progress" style="height: 1px;">
                              <div class="progress-bar" role="progressbar" style="width: 50%;" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                           </div>
                           <button type="button" class="position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">1</button>
                           <button type="button" class="position-absolute top-0 start-50 translate-middle btn btn-sm btn-secondary rounded-pill" style="width: 2rem; height:2rem;">2</button>
                           <button type="button" class="position-absolute top-0 start-100 translate-middle btn btn-sm btn-secondary rounded-pill" style="width: 2rem; height:2rem;">3</button>
                        </div>
                     </div>
                     <div class="card-body">
                        <div class="row">
                           <div class="col-md-12">
                              <div class="strpied-tabled-with-hover">
                                 <div class="">
                                    <div class="row">
                                       <div class="col-6">
                                          <h4 class="card-title">Host</h4>
                                       </div>
                                       <div class="col-6 text-end">
                                          <button type="button"
                                             class="btn btn-outline-info"
                                             data-bs-toggle="modal"
                                             data-bs-target="#hostForm"
                                             v-on:click="host_id = 0; refresh = Math.random()"
                                             >
                                          Add host
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="table-full-width table-responsive">
                                    <table class="table table-hover table-striped">
                                       <thead>
                                          <tr>
                                             <th>Title</th>
                                             <th>URL</th>
                                             <th>Date Created</th>
                                             <th>Active</th>
                                          </tr>
                                       </thead>
                                       <tbody v-if="hostList.length > 0">
                                          <tr v-for="list in hostList" v-bind:key="list.ID">
                                             <td>{{ list.title }}</td>
                                             <td>{{ list.url }}</td>
                                             <td>{{ list.CreatedAt | moment("ll") }}</td>
                                             <td>
                                                <button class="btn btn-outline-info btn-sm" v-if="active != list.ID" v-on:click="setActive(list.ID)">Active</button>
                                                <span v-else>
                                                <i class="fa fa-check text-success"></i>
                                                </span>
                                             </td>
                                             <td>
                                                <a href="javascript:void(0)"
                                                   class="text-warning me-2"
                                                   data-bs-toggle="modal"
                                                   data-bs-target="#hostForm"
                                                   v-on:click="updateHost(list.ID)"
                                                   >
                                                   <i class="far fa-edit"></i>
                                                </a>
                                                <a href="javascript:void(0)" class="text-danger" title="Delete" @click="deleteHost(list.ID)">
                                                <i class="fa fa-trash"></i>
                                                </a>
                                             </td>
                                          </tr>
                                       </tbody>
                                       <tbody v-else>
                                          <tr>
                                             <td>No host found</td>
                                             <td></td>
                                             <td></td>
                                             <td></td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="card-footer text-end">
                        <router-link :to="'/' + org_id + '/scan/' + project_id + '/step/2'" class="btn btn-lg btn-info text-light ps-4 pe-4">NEXT <i class="fas fa-angle-right"></i></router-link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

   <div class="modal fade" id="hostForm" tabindex="-1">
      <div class="modal-dialog">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title" id="exampleModalLabel">{{ title }} host</h5>
               <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeHostModal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <hostForm :host_id="host_id" v-on:callback="hostCallback" :key="refresh"/>
            </div>
         </div>
      </div>
   </div>

   </div>
</template>
<script>
   import hostForm from './Scanner/hostForm.vue'
   export default {
     components: {
         hostForm
     },
     data () {
       return {
         hostList: [],
         active: 0,
         project_id : this.$route.params.prod_id,
         org_id : this.$route.params.org_id,
         title: '',
         host_id: 0,
         refresh: Math.random()
       }
     },
     mounted() {
       this.init();
     },
     methods: {
       init() {
         const me = this;
         this.$axios.get(this.$server + 'organisation/'+ me.org_id +'/project/' + me.project_id + "/host")
         .then(res => {
           var r = res.data;
           if (r.success) {
               me.hostList = r.data;
               me.active = r.active_host[0].host_id;
           } else {
               me.$swal({
                  title: r.message,
                  icon: 'error'
               });
           }
         });
       },
       setActive(host_id) {
         const me = this;
         this.$axios.post(this.$server + 'organisation/' + this.org_id + '/project/' + this.project_id + '/host/active', {
             host_id : host_id
           })
         .then(res => {
           var r = res.data;
           if (r.success) {

               me.$swal({
                  title: r.message
               });
               me.init();
           }
         });
       },

       deleteHost(id){
           var c = confirm("Do you really want to delete this record?");
           if (c) {
               const me = this;
               this.$axios.delete(this.$server + 'organisation/' + this.org_id + '/project/' + this.project_id + '/host/' + id)
               .then(res => {
                   var r = res.data;
                   if (r.success) {
                       // reload data
                       this.init();
                       me.$swal({
                           title: r.message
                       });
                   }
               });
           }
       },

       hostCallback(val) {
         if (val == true) {
            document.getElementById("closeHostModal").click();
            this.init();
         }
         this.title = val;
       },

       updateHost(id) {
         this.host_id = id;
         this.refresh = Math.random();
       }

     }
   }
</script>